import React from 'react';
import { Row, Col, Label, UncontrolledCollapse , Collapse, Button } from "reactstrap";

import { formatNullableValue } from '../../../../utils/formatar';

export default class CardMovimentacao extends React.Component {

    constructor(props) {
        super(props);
    }

    
    render() {
        return (
            <Col xs={12} md={6} lg={4} >
                <div className="card-booking">
                    <Row>

                        {this.props.colunas.map((col, x) =>
                            <Col xs={6} className="px-0" key={x}>
                                <div className="info bg-cinza">
                                    <div className="titulo">{col.text}</div>
                                        <div className="valor" >{ col.formatter ?
                                            (
                                                col.formatExtraData ?
                                                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data), col, null, col.formatExtraData))
                                                :
                                                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                                            )
                                            :
                                            formatNullableValue(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data))
                                        }</div>
                                </div>
                            </Col>
                        )}
                    </Row>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/components/CardMovimentacao.js